import * as React from 'react';
import { ContactFormFieldsV2, ContactUsStateV2  } from './ContactFormEntities';
import './ContactForm.scss';
import { SectionDefinition } from './ContactFormSections';
import { LocationData } from '../Location/Entities';
import { ApplicationState } from '../../appState';
import { connect } from 'react-redux';
import { Api } from '../../Services/Api';
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { ReactNode } from 'react';
import { MobileDialog } from '../Dialog/MobileDialog';
import { UILayoutMode } from '../UILogicControl/UILogicControlEntities';
import ContactFormInputsV2 from './ContactFormInputsV2';
import { ContactFormDataV2 } from './ContactFormDataV2';
import { ContactUsRequestGuest, ContactUsRequestLoggedIn } from '../../Services/ContactUsContracts';
import { OptionalUI } from '../Booking/OptionalParts/OptionalUI';

interface PropsFromStore {
    IsMobileDevice: boolean;
    preferredLocation: LocationData;
    LoggedInUser: boolean;
}

/** Main component of the contact form. */
class ContactForm extends React.Component<PropsFromStore, ContactUsStateV2> {
    selectCategoryOption: ReactNode;

    constructor(props: PropsFromStore) {
        super(props);
        this.state = {
            selectedSection: 0,
        };

        this.updateSection = this.updateSection.bind(this);
    }

    // this type is really complex, too hard to describe. 
    public updateSection(newValue: any) {
        this.setState(
            {
                selectedSection: (newValue.target && newValue.target.value) || 0,
            });
    }

    public render() {
        // Get section data (dropdown options)
        const content = ContactFormDataV2;
        const current = content[this.state.selectedSection || 0];
        const selectOptions = content.map((entry, index) => {
            return <MenuItem value={index} key={index}>{entry.section}</MenuItem>
        })

        const labelText =  !!selectOptions ? "Enquiry type" : "";
        
        return (
            <div className="contact-us-form">
                <div className="contact-form-step">
                    <div className="step-data">
                        <div>
                            <h1 className="contact-title">How can we help</h1>
                        </div>
                        <p className="contact-us-description">Tell us about your enquiry.</p>
                        <p className="contact-form-info">Please select below (required)</p>
                        <div className="section-selection reason">
                            <FormControl variant="outlined" className="custom-select" fullWidth={true}>
                                <InputLabel id="section-selection-label">{labelText}</InputLabel>
                                <Select
                                    label={labelText}
                                    value={this.state.selectedSection}
                                    onChange={this.updateSection}
                                    autoFocus
                                >
                                    {selectOptions}
                                </Select>
                            </FormControl>
                        </div>
                    </div>
                    <div className="step-padding"></div>
                </div>

                <ContactFormInputsV2
                    locationData={this.props.preferredLocation}
                    currentData={current}
                    currentSection={this.state.selectedSection}
                    onSubmit={(formData: ContactFormFieldsV2) => this.onSubmit(formData, current)}
                    IsUserLoggedIn={this.props.LoggedInUser} />

                { this.props.IsMobileDevice && <MobileDialog /> }
            </div>
        );
    }

    /**
     * Format pickup date-time.
     */
    private getPickupDate(form: ContactFormFieldsV2): string {
        
        if (form.pickupDateTime) {
            return form.pickupDateTime.toISO();
        }

        return '';
    }

    /**
     * Prepare request data and send the request.
     */
    private onSubmit(form: ContactFormFieldsV2, contactEntry: SectionDefinition) {
        if (this.props.LoggedInUser) {
            return this.SubmitEnquiryLoggedIn(form, contactEntry);
        }
        else {
            return this.SubmitEnquiryGuest(form, contactEntry);
        }
    }

    private SubmitEnquiryLoggedIn(form: ContactFormFieldsV2, contactEntry: SectionDefinition) {
        let request: ContactUsRequestLoggedIn;
        const pickupDate = this.getPickupDate(form);

        if (this.state.selectedSection) {
            request = {
                State: this.GetBestStateCode(),
                Categorisation: [contactEntry.label],
                Notes: form.itemDescription,
                BookingDetails: null,
                HailDetails: null,
            };

            if (contactEntry.label != "General Enquiry") {
                if (form.selectedBookingHail === 'booking') {
                    request.BookingDetails = {
                        BookingReferenceNumber: form.bookingRef,
                        Name: form.bookingName,
                        PhoneNumber: form.bookingContactNumber,
                        BookingDateTime: pickupDate,
                        DriverId: form.driverId,
                        TaxiNumber: form.cabNumber,
                    };
                }
                else if (form.selectedBookingHail === 'hail') {
                    request.HailDetails = {
                        TaxiNumber: form.cabNumber,
                        DriverId: form.driverId,
                        BookingDateTime: pickupDate,
                        PickupLocation: form.pickup,
                        DropoffLocation: form.destination,
                    }
                }
            }            
            return Api.Contact.SubmitEnquiryForLoggedInUser(request);
        } else {
            return Promise.reject('Please select some section');
        }
    }

    private SubmitEnquiryGuest(form: ContactFormFieldsV2, contactEntry: SectionDefinition) {
        let request: ContactUsRequestGuest;
        const pickupDate = this.getPickupDate(form);

        if (this.state.selectedSection) {
            request = {
                FirstName: form.firstName,
                LastName: form.lastName,
                Phone: form.custContactNumber,
                Email: form.emailAddress,
                State: this.GetBestStateCode(),
                Categorisation: [contactEntry.label],
                Notes: form.itemDescription,
                BookingDetails: null,
                HailDetails: null,
            };

            if (contactEntry.label != "General Enquiry") {
                if (form.selectedBookingHail === 'booking') {
                    request.BookingDetails = {
                        BookingReferenceNumber: form.bookingRef,
                        Name: form.bookingName,
                        PhoneNumber: form.bookingContactNumber,
                        BookingDateTime: pickupDate,
                        DriverId: form.driverId,
                        TaxiNumber: form.cabNumber,
                    };
                }
                else if (form.selectedBookingHail === 'hail') {
                    request.HailDetails = {
                        TaxiNumber: form.cabNumber,
                        DriverId: form.driverId,
                        BookingDateTime: pickupDate,
                        PickupLocation: form.pickup,
                        DropoffLocation: form.destination,
                    }
                }
            }            
            return Api.Contact.SubmitEnquiryForGuest(request);
        } else {
            return Promise.reject('Please select some section');
        }
    }

    /**
     * If the state is non-deterministic, set VIC as default state.
     */
    private GetBestStateCode(): string {
        const location = this.props.preferredLocation;

        if (!location.isKnown) return "vic";

        return location.value.stateCode ?? "vic";
    }
}

function mapStateToProps(state: ApplicationState): PropsFromStore {
    return {
        preferredLocation: state.location.preferredLocation,
        IsMobileDevice: state.uiLogicControl.LayoutMode === UILayoutMode.Mobile,
        LoggedInUser: OptionalUI.LoggedInUser(state),
    }
}

export default connect(mapStateToProps)(ContactForm);